export const puapModels = {
    Acura: [
      "ADX",
      "CL",
      "CSX",
      "EL",
      "ILX",
      "Integra",
      "Legend",
      "MDX",
      "NSX",
      "RDX",
      "RL",
      "RLX",
      "RSX",
      "SLX",
      "TL",
      "TLX",
      "TSX",
      "Vigor",
      "ZDX",
    ],
    "Alfa Romeo": [
      "147",
      "164",
      "1750",
      "4C",
      "8C Competizione Spider",
      "Alfetta",
      "Giulia (952)",
      "Giulia 1600",
      "Giulia Berlina",
      "Giulietta",
      "GTV",
      "GTV6",
      "Milano",
      "Mito",
      "Spider",
      "Spider-1600",
      "Spider-1600 Duetto",
      "Spider-2000",
      "Stelvio",
      "TONALE",
    ],
    AMC: [
      "Ambassador",
      "AMX",
      "Concord",
      "Eagle",
      "Gremlin",
      "Hornet",
      "Javelin",
      "Matador",
      "Pacer",
      "Rambler American",
      "Spirit",
    ],
    "Aston Martin": [
      "DB11",
      "DB12",
      "DB7",
      "DB9",
      "DBS",
      "DBX",
      "Lagonda",
      "Rapide",
      "V12 Vantage",
      "V8",
      "V8 Vantage",
      "Valhalla",
      "Valiant",
      "VALOUR",
      "Vanquish",
      "Vanquish Zagato",
      "Vantage",
      "Virage",
    ],
    Audi: [
      "100",
      "200",
      "4000",
      "5000",
      "80 series",
      "90 series",
      "A3",
      "A4",
      "A4 Allroad",
      "A5",
      "A6",
      "A6 Allroad",
      "A7",
      "A7 e",
      "A8",
      "A8 e",
      "A8 L",
      "A8 L e",
      "Allroad",
      "Cabriolet",
      "Coupe",
      "Coupe GT",
      "e-tron",
      "e-tron GT",
      "e-tron Sportback",
      "Q3",
      "Q4 Etron",
      "Q5",
      "Q5 e",
      "Q6",
      "Q7",
      "Q8",
      "Q9",
      "R8",
      "RS 3",
      "RS 4",
      "RS 5",
      "RS 6",
      "RS 7",
      "RS e-tron GT",
      "RS Q8",
      "S e-tron GT",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7",
      "S8",
      "SQ5",
      "SQ6",
      "SQ7",
      "SQ8",
      "SQ9",
      "TT",
      "TT RS",
      "TTS",
      "V8 Quattro",
    ],
    Austin: [
      "Austin America",
      "Austin Marina",
    ],
    "Austin-Healey": [
      "100",
      "100-6",
      "3000",
      "Sprite",
    ],
    Bentley: [
      "Armoured Arnage",
      "Arnage",
      "Azure",
      "Bentayga",
      "Brooklands",
      "Continental",
      "Eight",
      "Flying Spur",
      "Mulsanne",
      "Roll Royce Silver Seraph",
      "Rolls-Royce Park Ward",
      "Turbo",
    ],
    BMW: [
      "128i",
      "135i",
      "1M",
      "228i",
      "230i",
      "318i",
      "318iC",
      "318iS",
      "318ti",
      "320i",
      "323i",
      "323iC",
      "323is",
      "325 / 325e",
      "325 / 325eS",
      "325Ci",
      "325i",
      "325i / 325is",
      "325iC",
      "325iS",
      "325ix",
      "325xi",
      "328Ci",
      "328d",
      "328i",
      "328iC",
      "328iS",
      "328xi",
      "330Ci",
      "330e",
      "330i",
      "330xi",
      "335",
      "335d",
      "335i",
      "335is",
      "335xi",
      "340i",
      "428i",
      "430i",
      "435i",
      "440i",
      "524td",
      "525i",
      "525iA",
      "525xi",
      "528e",
      "528i",
      "528xi",
      "530e",
      "530i",
      "530iA",
      "530xi",
      "533i",
      "535d",
      "535i",
      "535i / 535is",
      "535xi",
      "540d",
      "540i",
      "540iA",
      "545i",
      "550e",
      "550i",
      "633 csi",
      "635CSi",
      "640i",
      "640xi",
      "645Ci",
      "645i",
      "650i",
      "650i / Alpina B6",
      "650i / B6",
      "650xi",
      "730i",
      "733i",
      "735i",
      "735iL",
      "740e",
      "740i",
      "740iL",
      "740Li",
      "745e",
      "745i",
      "745Le",
      "745Li",
      "750e",
      "750i",
      "750i / Alpina B7",
      "750i / B7",
      "750iL",
      "750Li",
      "750Li / Alpina B7",
      "750Lxi",
      "750Lxi / Alpina B7",
      "750xi",
      "750xi / Alpina B7",
      "760i",
      "760Li",
      "840Ci",
      "840i",
      "850Ci",
      "850CSi",
      "850i",
      "Active E",
      "Active Hybrid 3",
      "Active Hybrid 5",
      "Active Hybrid 7",
      "Alpina",
      "Alpina B7",
      "Alpina B8",
      "i3",
      "i4",
      "i5",
      "i7",
      "i8",
      "iX",
      "iX3",
      "L7",
      "M2",
      "M235i",
      "M240i",
      "M3",
      "M340i",
      "M3Ci",
      "M4",
      "M440i",
      "M5",
      "M550i",
      "M6",
      "M760i",
      "M760Li",
      "M8",
      "M850i",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X7",
      "XM",
      "Z3",
      "Z4",
      "Z8",
    ],
    BrightDrop: [
      "Zevo",
    ],
    BYD: [
      "e6",
    ],
    Buick: [
      "Allure",
      "Cascada",
      "Century",
      "Coachbuilder",
      "Electra",
      "Enclave",
      "Encore",
      "Encore GX",
      "Envision",
      "Envista",
      "Estate Wagon",
      "Invicta",
      "LaCrosse",
      "LeSabre",
      "Lucerne",
      "Park Avenue",
      "Rainier",
      "Reatta",
      "Regal",
      "Regal TourX",
      "Rendezvous",
      "Riviera",
      "Roadmaster",
      "Skyhawk",
      "Skylark",
      "Somerset",
      "Special",
      "Terraza",
      "Verano",
      "Wildcat",
    ],
    Cadillac: [
      "60 Special",
      "Allante",
      "Armored Vehicle",
      "ATS",
      "Brougham",
      "Calais",
      "Catera",
      "Celestiq",
      "Cimarron",
      "Commercial Chassis",
      "CT4",
      "CT5",
      "CT6",
      "CTS",
      "Deville",
      "DTS",
      "Eldorado",
      "ELR",
      "Escalade",
      "Escalade ESV",
      "Escalade IQ",
      "Escalade IQL",
      "Fleetwood",
      "Funeral Coach",
      "Hearse",
      "Limousine",
      "Lyriq",
      "Optiq",
      "Seville",
      "SRX",
      "Stretch Limousine",
      "STS",
      "Vistiq",
      "XLR",
      "XT4",
      "XT5",
      "XT6",
      "XTS",
    ],
    Checker: [
      "A-11",
      "A-12",
      "Aerobus",
      "Marathon",
      "Superba",
      "Taxi",
    ],
    Chevrolet: [
      "3500",
      "3500HD",
      "3500HG",
      "Alero",
      "Astro Van",
      "Avalanche",
      "Aveo",
      "Bel Air",
      "Beretta",
      "Biscayne",
      "Blazer",
      "Blazer EV",
      "Bolt",
      "Bolt EUV",
      "Bolt EV",
      "BrightDrop",
      "C/K Pickup",
      "Camaro",
      "Caprice",
      "Caprice Police Vehicle",
      "Captiva Sport",
      "Cavalier",
      "Celebrity",
      "Chevelle",
      "Chevette",
      "Citation",
      "City Express",
      "Cobalt",
      "Colorado",
      "Corsica",
      "Corvair",
      "Corvette",
      "Cruze",
      "Cruze Limited",
      "Cutaway Chassis",
      "Cutaway Van",
      "El Camino",
      "Epica",
      "Equinox",
      "Equinox EV",
      "Express",
      "Forward Control",
      "G-Series",
      "Geo Prizm",
      "Geo Spectrum",
      "Geo Sprint",
      "GMT-400",
      "Hearse/Limo",
      "Hearse/Limo Commercial Chassis",
      "HHR",
      "Impala",
      "Impala Limited",
      "Kalos",
      "Lumina",
      "Lumina APV",
      "LUV",
      "Malibu",
      "Malibu Classic",
      "Malibu Limited",
      "Matiz",
      "Metro",
      "Military Truck",
      "Monte Carlo",
      "Monza",
      "Nova",
      "Onix",
      "Optra",
      "Orlando",
      "P - Series",
      "P Truck Forward",
      "R Conventional",
      "S-10 Blazer",
      "S-10 Pickup",
      "Silverado",
      "Silverado EV",
      "Silverado HD",
      "Silverado LD",
      "Silverado LTD",
      "Sonic",
      "Spark",
      "SS",
      "SSR",
      "Suburban",
      "Suburban HD",
      "Tahoe",
      "Tracker",
      "Trailblazer",
      "Traverse",
      "Traverse Limited",
      "Trax",
      "U100",
      "Uplander",
      "V Conventional",
      "Vega",
      "Venture",
      "Volt",
    ],
    Chrysler: [
      "200",
      "300",
      "300C",
      "Aspen",
      "Caravan",
      "Cirrus",
      "Concorde",
      "Concorde/LHS",
      "Conquest",
      "Cordoba",
      "Crossfire",
      "Daytona",
      "Dynasty",
      "E-CLASS",
      "EXECUTIVE",
      "FIFTH AVENUE",
      "Grand Caravan",
      "Grand Voyager",
      "Imperial",
      "Intrepid",
      "LASER",
      "LeBaron",
      "LHS",
      "Neon",
      "New Yorker",
      "NEWPORT",
      "Pacifica",
      "Prowler",
      "PT Cruiser",
      "SALON",
      "Saratoga",
      "Sebring",
      "Shadow",
      "Stratus",
      "TC",
      "Town and Country",
      "Viper",
      "Vision",
      "Voyager",
      "Windsor",
    ],
    Coda: [
      "CODA",
    ],
    Cruise: [
      "Cruise AV",
    ],
    Daewoo: [
      "Lanos",
      "Leganza",
      "Nubira",
    ],
    Daihatsu: [
      "Charade",
      "Rocky",
    ],
    Datsun: [
      "1200",
      "1600",
      "200SX",
      "210",
      "240Z",
      "260Z",
      "280Z",
      "280ZX",
      "310",
      "510",
      "520/521 Pickup",
      "610",
      "620 Pickup",
      "710",
      "720 Pickup",
      "810",
      "B210",
      "F10",
      "Patrol",
    ],
    DeLorean: [
      "DMC-12",
    ],
    Dodge: [
      "400",
      "600",
      "ARIES",
      "Aspen",
      "Avenger",
      "Caliber",
      "Caravan",
      "Caravan/Grand Caravan",
      "Challenger",
      "Charger",
      "Colt",
      "Conquest",
      "Coronet",
      "D-Series",
      "D50",
      "Dakota",
      "Dart",
      "Daytona",
      "Demon",
      "DIPLOMAT",
      "Durango",
      "Dynasty",
      "Grand Caravan",
      "HORNET",
      "Intrepid",
      "Journey",
      "LANCER",
      "Magnum",
      "Mini Ram",
      "Mirada",
      "Monaco",
      "Neon",
      "Nitro",
      "OMNI",
      "Polara",
      "Raider",
      "Ram",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Ram 4500",
      "RAM 50",
      "Ram 5500",
      "Ram Chassis Cab",
      "Ram Van",
      "Ram Van 1500",
      "Ram Van 2500",
      "Ram Van 3500",
      "Ram Wagon",
      "Ramcharger",
      "Rampage",
      "RD200 / RD250",
      "Royal Mini Ram Van",
      "Shadow",
      "Shelby Charger",
      "Spirit",
      "Sprinter",
      "Sprinter 2500",
      "Sprinter 3500",
      "ST.REGIS",
      "Stealth",
      "Stratus",
      "Viper",
      "W-Series",
    ],
    Eagle: [
      "2000 GTX",
      "Medallion",
      "Premier",
      "Summit",
      "Talon",
      "Vision",
      "Vista",
      "Wagon",
    ],
    Ferrari: [
      "12Cilindri",
      "296 GTB",
      "296 GTS",
      "296 Speciale",
      "296 Speciale A",
      "3.2 Mondial",
      "308 Convertible",
      "308GTB",
      "308GTB Quattrovalvole",
      "308GTBi",
      "308GTS",
      "308GTS Quattrovalvole",
      "308GTSi",
      "328",
      "328 GTB",
      "328 GTS",
      "348 Spider",
      "348 tb",
      "348 ts",
      "355 Berlinetta",
      "355 GTS",
      "355 Spider",
      "360 Modena",
      "360 Spider",
      "430 Scuderia",
      "430 Scuderia Spider",
      "456 GT",
      "456 MGT",
      "456 MGTA",
      "458 Italia",
      "458 Speciale",
      "458 Speciale Spider",
      "458 Spider",
      "488 GTB",
      "488 GTS",
      "488 Pista",
      "488 Pista Spider",
      "488 Spider",
      "512 TR",
      "550 Barchetta",
      "550 Maranello",
      "575 M Maranello",
      "599 GTB",
      "599 GTB Fiorano",
      "599 GTO",
      "612 Scaglietti",
      "812 Competizione",
      "812 Competizione A",
      "812 Superfast",
      "812GTS",
      "849 Testarossa",
      "Amalfi",
      "California",
      "California T",
      "Challenge Stradale",
      "Daytona SP3",
      "Enzo",
      "F12 Berlinetta",
      "F12 Special Series",
      "F12 tdf (Tour de France)",
      "F164BCB",
      "F355",
      "F40",
      "F430",
      "F430 Coupe",
      "F430 Spider",
      "F50",
      "F60 America",
      "F8 Spider",
      "F8 Tributo",
      "F80",
      "FF",
      "GTC4Lusso",
      "La Ferrari",
      "Luce",
      "Mondial 8",
      "Mondial T",
      "Monza SP1/SP2",
      "Portofino",
      "Portofino M",
      "Purosangue",
      "Roma",
      "Roma Spider",
      "SF90 Spider",
      "SF90 Stradale",
      "SF90 XX Spider",
      "SF90 XX Stradale",
      "Testarossa",
    ],
    Fiat: [
      "124 Spider",
      "500",
      "500e",
      "500L",
      "500X",
      "Brava",
      "Ducato",
      "Freemont",
      "Spider 2000",
      "Strada",
      "X 1/9",
    ],
    Fisker: [
      "Karma",
      "Ocean",
    ],
    Ford: [
      "34",
      "Aerostar",
      "Aspire",
      "Bronco",
      "Bronco II",
      "Bronco Sport",
      "C-Max",
      "Contour",
      "Courier",
      "Crown Victoria",
      "E-100",
      "E-150",
      "E-250",
      "E-350",
      "E-450",
      "E-Transit",
      "Ecosport",
      "Edge",
      "Escape",
      "Escort",
      "Excursion",
      "Expedition",
      "Expedition EL",
      "Expedition MAX",
      "Explorer",
      "Explorer Sport",
      "Explorer Sport Trac",
      "F-100",
      "F-150",
      "F-150 Heritage",
      "F-250",
      "F-350",
      "F-450",
      "F-550",
      "F-59",
      "F-600",
      "F-650",
      "F-750",
      "Fairmont",
      "Festiva",
      "Fiesta",
      "Five Hundred",
      "Flex",
      "Focus",
      "Freestar",
      "Freestyle",
      "Fusion",
      "Granada",
      "GT",
      "GT MKII",
      "Laser",
      "LTD",
      "Maverick",
      "Mustang",
      "Mustang GTD",
      "Mustang Mach-E",
      "Probe",
      "Ranger",
      "Taurus",
      "Taurus X",
      "Tempo",
      "Thunderbird",
      "Transit",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Windstar",
      "ZX2",
    ],
    Freightliner: [
      "Sprinter",
    ],
    Genesis: [
      "Electrified G80",
      "Electrified GV70",
      "G70",
      "G80",
      "G90",
      "GV60",
      "GV60 Magma",
      "GV70",
      "GV80",
    ],
    Geo: [
      "Metro",
      "Prizm",
      "Spectrum",
      "Sprint",
      "Storm",
      "Tracker",
    ],
    GMC: [
      "Acadia",
      "C/K Pickup",
      "Caballero",
      "Canyon",
      "Cruise Origin AV",
      "Cutaway Chassis",
      "Cutaway Van",
      "Electric Vehicle",
      "Envoy",
      "Forward Control",
      "Geo Tracker",
      "GMT-400",
      "Hummer EV Pickup",
      "Hummer EV SUV",
      "Jimmy",
      "Jimmy Utility",
      "Magna Van",
      "P Truck Forward",
      "R Conventional",
      "Rally",
      "S15 Pickup",
      "S15 Utility",
      "Safari Van",
      "Savana",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra",
      "Sierra Denali 1500",
      "Sierra Denali 2500",
      "Sierra Denali 3500",
      "Sierra EV",
      "Sierra HD",
      "Sierra Limited",
      "Sonoma",
      "Suburban",
      "Terrain",
      "Typhoon",
      "V Conventional",
      "Value Van",
      "Vandura",
      "Yukon",
      "Yukon XL",
    ],
    Honda: [
      "Accord",
      "Accord Crosstour",
      "Civic",
      "CIVIC SI",
      "Civic Type R",
      "Clarity",
      "CR-V",
      "CR-Z",
      "Crosstour",
      "del Sol",
      "Element",
      "EV Plus",
      "FCX Clarity",
      "Fit",
      "HR-V",
      "Insight",
      "Odyssey",
      "Passport",
      "Pilot",
      "Prelude",
      "Prologue",
      "Ridgeline",
      "S2000",
    ],
    Hummer: [
      "H1",
      "H2",
      "H3",
      "H3T",
    ],
    Hyundai: [
      "Accent",
      "Azera",
      "Elantra",
      "Elantra GT",
      "Elantra N",
      "Elantra Touring",
      "Entourage",
      "Equus",
      "Excel",
      "Genesis",
      "Genesis Coupe",
      "Ioniq",
      "Ioniq 5",
      "IONIQ 5 N",
      "Ioniq 6",
      "Ioniq 6 N",
      "Ioniq 9",
      "Kona",
      "Kona Electric",
      "Kona N",
      "Nexo",
      "Palisade",
      "Pony",
      "Santa Cruz",
      "Santa Fe",
      "Santa Fe Sport",
      "Santa Fe XL",
      "Scoupe",
      "Sonata",
      "Stellar",
      "Tiburon",
      "Tucson",
      "Veloster",
      "Veloster N",
      "Venue",
      "Veracruz",
      "XG300",
      "XG350",
    ],
    Ineos: [
      "Grenadier",
      "Grenadier Quartermaster",
    ],
    Infiniti: [
      "EX35",
      "FX35",
      "FX37",
      "FX45",
      "FX50",
      "G20",
      "G25",
      "G35",
      "G37",
      "I30",
      "I35",
      "J30",
      "JX35",
      "M30",
      "M35",
      "M35h",
      "M37",
      "M45",
      "M56",
      "Q40",
      "Q45",
      "Q50",
      "Q60",
      "Q70",
      "Q70L",
      "QX30",
      "QX4",
      "QX50",
      "QX55",
      "QX56",
      "QX60",
      "QX65",
      "QX70",
      "QX80",
    ],
    International: [
      "Scout 80",
      "Scout 800",
      "Scout II",
      "Scout Terra",
      "Scout Traveler",
      "Travelall",
      "Travelette",
    ],
    Isuzu: [
      "4000 Series Medium Duty",
      "Amigo",
      "Ascender",
      "Axiom",
      "Hombre",
      "i-280",
      "i-290",
      "i-350",
      "i-370",
      "I-Mark",
      "IMPULSE",
      "Oasis",
      "Pickup",
      "REACH",
      "Rodeo",
      "Rodeo/Amigo",
      "Stylus",
      "Trooper",
      "Trooper II",
      "VehiCross",
    ],
    Jaguar: [
      "E-PACE",
      "E-Type",
      "F-PACE",
      "F-TYPE",
      "I-PACE",
      "Mark 2",
      "S-Type",
      "Type 01",
      "Vanden Plas",
      "X-Type",
      "XE",
      "XF",
      "XJ",
      "XJ12",
      "XJ6",
      "XJ8",
      "XJR",
      "XJS",
      "XK",
      "XK120",
      "XK140",
      "XK150",
      "XK8",
    ],
    Jeep: [
      "Cherokee",
      "CJ-2A",
      "CJ-3A",
      "CJ-3B",
      "CJ-5",
      "CJ-6",
      "CJ-7",
      "CJ-8 Scrambler",
      "Comanche",
      "Commander",
      "Compass",
      "DJ-5",
      "DJ-6",
      "Gladiator",
      "Grand Cherokee",
      "Grand Cherokee L",
      "Grand Wagoneer",
      "Grand Wagoneer L",
      "J-10",
      "J-20",
      "Jeepster",
      "Jeepster Commando",
      "Liberty",
      "Patriot",
      "Recon",
      "Renegade",
      "Wagoneer",
      "Wagoneer L",
      "Wagoneer S",
      "Willys MB",
      "Wrangler",
      "Wrangler JK",
    ],
    "Jensen-Healey": [
      "Jensen GT",
      "Jensen-Healey",
    ],
    Karma: [
      "GS-6",
      "Gyesera",
      "Revero",
      "Revero GT",
    ],
    KIA: [
      "Amanti",
      "Borrego",
      "Cadenza",
      "Carnival",
      "EV3",
      "EV6",
      "EV9",
      "Forte",
      "Forte Koup",
      "K4",
      "K5",
      "K900",
      "Niro",
      "Optima",
      "Rio",
      "Rondo",
      "Sedona",
      "Seltos",
      "Sephia",
      "Sephia II/Spectra",
      "Sorento",
      "Soul",
      "Soul EV",
      "Spectra",
      "Sportage",
      "Stinger",
      "Telluride",
    ],
    Lamborghini: [
      "Aventador",
      "Diablo",
      "Gallardo",
      "Huracan",
      "Huracan STO",
      "Murcielago",
      "Revuelto",
      "Roadster",
      "Temerario",
      "URUS",
    ],
    "Land Rover": [
      "Defender",
      "Discovery",
      "Discovery Sport",
      "Freelander",
      "LR2",
      "LR3",
      "LR4",
      "New Range Rover",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar",
      "Series I",
      "Series II / IIA",
      "Series III",
    ],
    Lexus: [
      "CT",
      "ES",
      "GS",
      "GX",
      "HS",
      "IS",
      "LC",
      "LFA",
      "LS",
      "LX",
      "NX",
      "RC",
      "RC F",
      "RX",
      "RZ",
      "SC",
      "TX",
      "TZ",
      "UX",
    ],
    Lincoln: [
      "Aviator",
      "Blackwood",
      "Continental",
      "Corsair",
      "LS",
      "Mark",
      "Mark III",
      "Mark IV",
      "Mark LT",
      "Mark V",
      "Mark VI",
      "Mark VII",
      "Mark VIII",
      "MKC",
      "MKS",
      "MKT",
      "MKX",
      "MKZ",
      "Nautilus",
      "Navigator",
      "Navigator L",
      "Town Car",
      "Versailles",
      "Zephyr",
    ],
    Lucid: [
      "Air",
      "Gravity",
    ],
    Lotus: [
      "2-Eleven",
      "Eclat",
      "Elan",
      "ELETRE",
      "Elise",
      "Elite",
      "Emira",
      "Esprit",
      "Europa",
      "Evora",
      "Exige",
      "Turbo Esprit",
    ],
    Mahindra: [
      "Mahindra TR20",
      "Mahindra TR40",
    ],
    Maserati: [
      "228",
      "430",
      "Biturbo",
      "Coupe",
      "Ghibli",
      "Grancabrio",
      "Granturismo",
      "GRANTURISMO / GRANCABRIO",
      "Grecale",
      "Levante",
      "MC20",
      "MCPura",
      "Merak",
      "Quattroporte",
      "Spyder",
      "TC",
    ],
    Maybach: [
      "57",
      "57S",
      "62",
      "62S",
    ],
    Mazda: [
      "323",
      "626",
      "929",
      "B-Series",
      "CX-3",
      "CX-30",
      "CX-5",
      "CX-50",
      "CX-7",
      "CX-70",
      "CX-9",
      "CX-90",
      "GLC",
      "Mazda2",
      "Mazda3",
      "Mazda5",
      "Mazda6",
      "Millenia",
      "MPV",
      "MX-3",
      "MX-30",
      "MX-5",
      "MX-6",
      "Navajo",
      "Protege",
      "RX-7",
      "RX-8",
      "Tribute",
    ],
    McLaren: [
      "540C",
      "570GT",
      "570S",
      "600LT",
      "620R",
      "625C",
      "650S",
      "675LT",
      "720S",
      "750S",
      "765LT",
      "ARTURA",
      "ELVA",
      "GT",
      "GTS",
      "MP4-12C",
      "P1",
      "SENNA",
      "SENNA GTR",
    ],
    "Mercedes Benz": [
      "190",
      "240",
      "260",
      "280",
      "300",
      "350",
      "380",
      "400",
      "420",
      "500",
      "560",
      "600",
      "A-Class",
      "AMG GT",
      "B-Class",
      "C-Class",
      "CL-Class",
      "CLA-Class",
      "CLE",
      "CLK-Class",
      "CLS-Class",
      "E-Class",
      "EQB-Class",
      "EQC-Class",
      "EQE-Class Sedan",
      "EQE-Class SUV",
      "EQS-Class Sedan",
      "EQS-Class SUV",
      "eSprinter",
      "G-Class",
      "GL-Class",
      "GLA-Class",
      "GLB-Class",
      "GLC-Class",
      "GLE-Class",
      "GLK-Class",
      "GLS-Class",
      "M-Class",
      "Metris",
      "ML-Class",
      "R-Class",
      "S-Class",
      "SL-Class",
      "SLC-Class",
      "SLK",
      "SLR",
      "SLS-Class",
      "Sprinter",
      "Sprinter 1500",
      "Sprinter 2500",
      "Sprinter 3500",
      "Sprinter 4500",
    ],
    Mercury: [
      "Bobcat",
      "Capri",
      "Comet",
      "Cougar",
      "Cyclone",
      "Grand Marquis",
      "Lynx",
      "Marauder",
      "Mariner",
      "MARQUIS",
      "Meteor",
      "Milan",
      "Monarch",
      "Montclair",
      "Montego",
      "Monterey",
      "Mountaineer",
      "Mystique",
      "Park Lane",
      "Sable",
      "Topaz",
      "Tracer",
      "Villager",
      "Zephyr",
    ],
    Merkur: [
      "Scorpio",
      "XR4Ti",
    ],
    MG: [
      "MGA",
      "MGB",
      "MGC",
      "Midget",
    ],
    Mini: [
      "Clubman",
      "Cooper",
      "Cooper Convertible",
      "Cooper Coupe",
      "Cooper Roadster",
      "Countryman",
      "Hardtop",
      "Paceman",
    ],
    Mitsubishi: [
      "3000GT",
      "Cordia",
      "Diamante",
      "Eclipse",
      "Eclipse Cross",
      "Endeavor",
      "Expo",
      "Galant",
      "i-MiEV",
      "Lancer",
      "Lancer Evolution",
      "Lancer SportBack",
      "Mighty Max",
      "Mirage",
      "Mirage G4",
      "Montero",
      "Montero Sport",
      "Outlander",
      "Outlander Sport",
      "Precis",
      "Raider",
      "RVR",
      "Sigma",
      "SP",
      "Space Wagon",
      "SPX",
      "Starion",
      "Tredia",
      "Truck",
      "Van",
      "Wagon",
    ],
    Nissan: [
      "200SX",
      "240SX",
      "300ZX",
      "350Z",
      "370Z",
      "Altima",
      "Altra",
      "Altra-EV",
      "ARIYA",
      "Armada",
      "Axxess",
      "Cube",
      "Frontier",
      "GT-R",
      "Juke",
      "Kicks",
      "Kicks Play",
      "Leaf",
      "Maxima",
      "Micra",
      "Murano",
      "NISSAN Z",
      "NV",
      "NV200",
      "NX",
      "Pathfinder",
      "Pickup",
      "PULSAR",
      "Quest",
      "Rogue",
      "Rogue Select",
      "Rogue Sport",
      "Sentra",
      "Sentra Classic",
      "Stanza",
      "Stanza Wagon",
      "Titan",
      "Van",
      "Versa",
      "Versa Note",
      "X-Trail",
      "Xterra",
    ],
    Oldsmobile: [
      "4-4-2",
      "Achieva",
      "Alero",
      "Aurora",
      "Bravada",
      "Ciera",
      "Custom Cruiser",
      "Cutlass",
      "Cutlass Calais",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Dynamic 88",
      "Eighty Eight (88)",
      "F-85",
      "Firenza",
      "Intrigue",
      "Jetstar 88",
      "Jetstar I",
      "LSS",
      "Ninety Eight (98)",
      "Omega",
      "Regency",
      "Silhouette",
      "Starfire",
      "Toronado",
      "Vista Cruiser",
    ],
    Opel: [
      "1900 (Ascona A)",
      "GT",
      "Kadett A",
      "Kadett B",
      "Manta",
      "Rekord P1/P2",
    ],
    Peugeot: [
      "304",
      "403",
      "404",
      "405",
      "504",
      "505",
      "604",
    ],
    Plymouth: [
      "Acclaim",
      "Arrow",
      "Barracuda",
      "Belvedere",
      "Breeze",
      "CARAVELLE",
      "Champ",
      "Colt",
      "CONQUEST",
      "Duster",
      "Fury",
      "GRAN FURY",
      "Grand Voyager",
      "GTX",
      "HORIZON",
      "Laser",
      "Neon",
      "Prowler",
      "RELIANT",
      "Road Runner",
      "SAPPORO",
      "Satellite",
      "Scamp",
      "Sundance",
      "Trailduster",
      "TURISMO",
      "Valiant",
      "Volare",
      "Voyager",
    ],
    Polestar: [
      "Polestar 1",
      "Polestar 2",
      "Polestar 3",
      "Polestar 4",
    ],
    Pontiac: [
      "6000",
      "Acadian",
      "Astre",
      "Aztek",
      "Bonneville",
      "Catalina",
      "Executive",
      "Fiero",
      "Firebird",
      "Firefly",
      "G3",
      "G5",
      "G6",
      "G8",
      "Grand AM",
      "Grand Lemans",
      "Grand Prix",
      "Grand Safari",
      "GTO",
      "J2000",
      "Laurentian",
      "Lemans",
      "Matiz",
      "Montana",
      "Montana SV6",
      "Parisienne",
      "Phoenix",
      "Pursuit",
      "Safari",
      "Solstice",
      "Star Chief",
      "Sunbird",
      "Sunbird 2000",
      "Sunburst",
      "Sunfire",
      "T1000",
      "Tempest",
      "Torrent",
      "Trans Sport",
      "Ventura",
      "Vibe",
      "Wave",
    ],
    Porsche: [
      "356",
      "718 Boxster",
      "718 Cayman",
      "718 Spyder",
      "911",
      "912",
      "914",
      "918",
      "924",
      "928",
      "944",
      "968",
      "Boxster",
      "Carrera GT",
      "Cayenne",
      "Cayman",
      "Macan",
      "Panamera",
      "Taycan",
    ],
    RAM: [
      "Cargo Van",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "Promaster City",
      "Truck 1500 Series",
      "Truck 2500 Series",
      "Truck 3500 Series",
    ],
    Renault: [
      "18i",
      "Alliance",
      "Dauphine",
      "Encore",
      "Fuego",
      "LeCar",
      "Medallion",
      "R10",
      "R16",
      "R8",
    ],
    Rivian: [
      "EDV",
      "R1S",
      "R1T",
      "R2",
      "RCV",
    ],
    "Rolls-Royce": [
      "Camargue",
      "Corniche",
      "Cullinan",
      "Dawn",
      "Flying Spur",
      "Ghost",
      "Park Ward",
      "Phantom",
      "Silver Dawn",
      "Silver Seraph",
      "Silver Spirit",
      "Silver Spur",
      "Spectre",
      "Touring Limousine",
      "Wraith",
    ],
    SAAB: [
      "9-2X",
      "9-3",
      "9-4x",
      "9-5",
      "9-7X",
      "900",
      "9000",
      "99",
    ],
    Saturn: [
      "Astra",
      "Aura",
      "Ion",
      "L200",
      "L300",
      "LS",
      "LS1",
      "LS2",
      "LW1",
      "LW2",
      "LW200",
      "LW300",
      "Outlook",
      "Relay",
      "SC1",
      "SC2",
      "Sky",
      "SL",
      "SL1",
      "SL2",
      "SL3",
      "SW1",
      "SW2",
      "Vue",
    ],
    Scion: [
      "Scion FR-S",
      "Scion iA",
      "Scion iM",
      "Scion iQ",
      "Scion tC",
      "Scion xA",
      "Scion xB",
      "Scion xD",
    ],
    Smart: [
      "EQ Fortwo",
      "Fortwo",
      "Fortwo Cabrio",
      "Fortwo Electric Drive",
    ],
    Sterling: [
      "825",
      "827",
    ],
    Studebaker: [
      "Avanti",
      "Champ",
      "Champion",
      "Commander",
      "Lark",
    ],
    Subaru: [
      "Ascent",
      "B9 Tribeca",
      "Baja",
      "Brat",
      "BRZ",
      "Crosstrek",
      "DL",
      "Forester",
      "GL",
      "GL-10",
      "GLF",
      "Impreza",
      "Justy",
      "Legacy",
      "Loyale",
      "Outback",
      "RX",
      "Solterra",
      "Standard",
      "SVX",
      "Trailseeker",
      "Uncharted",
      "WRX",
      "XT",
      "XT6",
      "XV CrossTrek",
    ],
    Suzuki: [
      "Aerio",
      "Equator",
      "Esteem",
      "Forenza",
      "Forsa",
      "Grand Vitara",
      "Grand Vitara XL-7",
      "Kizashi",
      "Reno",
      "Samurai",
      "Sidekick",
      "Sidekick Sport",
      "Swift",
      "SX4",
      "Verona",
      "Vitara",
      "X-90",
      "XL-7",
    ],
    Tesla: [
      "Cybertruck",
      "Model 3",
      "Model S",
      "Model X",
      "Model Y",
      "Roadster",
    ],
    "Th!nk": [
      "City",
    ],
    Toyota: [
      "4-Runner",
      "86",
      "Avalon",
      "bZ",
      "bZ Woodland",
      "bZ4X",
      "C-HR",
      "Camry",
      "Camry Solara",
      "Cargo Van",
      "Celica",
      "Corolla",
      "Corolla Cross",
      "COROLLA iM",
      "Corolla Matrix",
      "Corona",
      "Cressida",
      "Crown",
      "Crown Signia",
      "Echo",
      "FCHV-adv",
      "FJ Cruiser",
      "GR Corolla",
      "GR86",
      "Grand Highlander",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "MR2",
      "Paseo",
      "Pick-Up",
      "Previa",
      "Prius",
      "Prius C",
      "Prius Plug-in",
      "Prius Prime",
      "Prius V",
      "RAV4",
      "RAV4 Prime",
      "Sequoia",
      "Sienna",
      "Starlet",
      "Supra",
      "T100",
      "Tacoma",
      "Tercel",
      "Tundra",
      "Van",
      "Venza",
      "Yaris",
      "Yaris iA",
    ],
    Triumph: [
      "GT6",
      "Spitfire",
      "Stag",
      "TR2/TR3",
      "TR4/TR250",
      "TR6",
      "TR7",
      "TR8",
    ],
    VinFast: [
      "VF 6",
      "VF 7",
      "VF 8",
      "VF 9",
    ],
    Volkswagen: [
      "Arteon",
      "Atlas",
      "Atlas Cross Sport",
      "Beetle",
      "Cabrio",
      "CABRIOLET",
      "CC",
      "Corrado",
      "Dasher",
      "e-Golf",
      "Eos",
      "EuroVan",
      "FOX",
      "GLI",
      "Golf",
      "Golf Alltrack",
      "Golf GTI",
      "Golf III",
      "Golf R",
      "Golf SportWagen",
      "GTI",
      "ID. Buzz",
      "ID.4",
      "Jetta",
      "Jetta GLI",
      "Jetta SportWagen",
      "Jetta Wagon",
      "KOMBI",
      "Passat",
      "Phaeton",
      "Quantum",
      "R32",
      "Rabbit",
      "Routan",
      "Scirocco",
      "Taos",
      "Tiguan",
      "Tiguan Limited",
      "Touareg",
      "Vanagon",
    ],
    Volvo: [
      "140 Series",
      "164",
      "240 Series",
      "260 Series",
      "740 Series",
      "760 Series",
      "780 Series",
      "850 Series",
      "940 Series",
      "960 Series",
      "Amazon",
      "C30",
      "C40",
      "C70",
      "C70 / C30",
      "EC40",
      "EX30",
      "EX30 CC",
      "EX40",
      "EX60",
      "EX60 CC",
      "EX90",
      "P1800",
      "S40",
      "S60",
      "S60 Cross Country",
      "S60CC",
      "S70",
      "S80",
      "S90",
      "V40",
      "V50",
      "V60",
      "V60CC",
      "V70",
      "V90",
      "V90CC",
      "XC40",
      "XC60",
      "XC70",
      "XC90",
    ],
    Yugo: [
      "Cabrio",
      "GV",
      "GVC",
      "GVL",
      "GVX",
    ],
  };
